import React from 'react'
import images from '../../../../app/utlis/image'

const HealthCustom = () => {
    return (
        <div className='flex flex-col md:flex-row bg-health-service-bg bg-no-repeat bg-center bg-cover w-full bg-purple pt-4'>
            <img src={images.HEALTHDOCAVATAR} className='w-full md:w-2/5 h-auto' />
            <div className='text-start p-4 md:p-12 md:pr-8 md:!pl-10 text-white flex flex-col gap-2'>
                <div className='text-3xl md:text-4xl font-bold mb-2 md:mb-4 leading-snug'>Start your healthcare <br />
                    App development <br /> today
                </div>
                <div className='text-base md:text-xl leading-6 md:leading-8 pr-0 md:pr-72'>Ready to improve patient care and streamline
                    healthcare operations with a custom app?
                    Our team of experts is here to build a secureand scalable healthcare solution tailored to
                    your needs. Contact us today for a free
                    consultation.</div>
            </div>
        </div>
    )
}

export default HealthCustom
